import PropTypes from 'prop-types';

export const propTypes = {
  showModal: PropTypes.func,
};
